// @ vendors
const get = require('lodash/object/get');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { findElementbyId } = require('routes/contractsView/utilities/contractStateHelper');
const { calculateContract } = require('utilities/ibanHelper');
// @ actions
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
import { registerDocuments } from 'actions/registerDocuments';
// @ constants
const actionTypes = require('constants/actionTypes');
const signaturePatternActions = require('actions/signaturePattern');
const { hireContractFailure }  = require('actions/contracts');
const gdprConsentsActions = require('actions/gdprConsents');
const {
    ACCOUNT_INTERVENTION_INDISTINCT_CODE,
    ACCOUNT_INTERVENTION_OWNER_CODE,
    HIRE_E_ACCOUNT_MANAGER
} = require('constants/index');
const { E_ACCOUNT_LOAN_PRODUCT_ALIAS } = require('constants/hiringProductInformation');

const requestAccounts = () => (dispatch) =>
    APIGet(dispatch, apiURLBuilder.getURL('hireEAccountLoan'), {})
        .then(response => response.listaCredPrecon.credPrecon)
        .catch(response => response.error);

const hireEAccountSuccess = (response) => {
    const contractNumber = get(response, 'cuentaSeleccionada.numerodecontrato');
    const product = get(response, 'cuentaSeleccionada.producto');

    response.numeroCuenta = calculateContract(product+contractNumber);

    return {
        type: actionTypes.HIRE_ACCOUNT_SUCCESS,
        payload: {
            response
        }
    }
}

const setEAccountLoan = (dispatch, data, getState) => {
    const requestData = {
        header: {
            version: 2,
        },
        query: data
    };
    const immContracts = getState().contracts;
    const contractType = immContracts.get('contract_type');
    //Adding property for passport logic
    const termsAndsCondsHiringData = [{
        passportProductId: E_ACCOUNT_LOAN_PRODUCT_ALIAS,
    }];

    return APIPost(dispatch, apiURLBuilder.getURL('hireEAccountLoan'), requestData)
        .then(response => {
            const contractNumber = response.cuentaSeleccionada.numerodecontrato;
            const product = response.cuentaSeleccionada.producto;
            const operationProcessId = getState().contractualPolling.get('operationProcessId');
            const preContractualOperationProcessId = getState().preContractualPolling.get('operationProcessId');

            const registerDocumentsData =  {
                query: {
                    processes: [
                        {
                            processRelation: "PRECONTRACTUAL",
                            operationProcessId: preContractualOperationProcessId
                        },
                        {
                            processRelation: "CONTRACTUAL",
                            operationProcessId: operationProcessId
                        }
                    ],
                    productAlias: E_ACCOUNT_LOAN_PRODUCT_ALIAS,
                    contract: contractNumber,
                    product: product,
                }
            }
            dispatch(hireEAccountSuccess(response));
            dispatch(setTermsAndCondsInfo(contractType, termsAndsCondsHiringData));
            dispatch(registerDocuments(registerDocumentsData));
        })
        .catch(response => {
            dispatch(hireContractFailure({
                error: {
                    description: response.error.description,
                    timeoutError: response.exception && response.exception.status === 504
                }
            }))
        })
};

const hireEAccountLoan = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const { contracts: immContracts } = getState();
        const accountId = findElementbyId(immContracts.get('card_details'), 'cta_seleccionada');
        const accountDefinition = immContracts.getIn(['mainAccount','data','accountDefinition']);
        const productId = accountDefinition.get('productId');
        const standard = accountDefinition.get('standard');
        const subtype = accountDefinition.get('subtype');
        const type = accountDefinition.get('type');
        const immAccount = getState().accounts.getIn(['byId', accountId]);
        const immInterveners = immContracts.get('interveners');
        const firstTitularIndex = immInterveners.findIndex(immIntervener =>
            immIntervener.get('typeNumber') === '01'
        );
        const firstTitular = immInterveners.get(firstTitularIndex);
        const groupedInterveners = immInterveners.delete(firstTitularIndex)
            .groupBy(intervener => intervener.get('typeNumber'));
        const parsedInterveners = [];

        groupedInterveners.forEach((immIntervenerList, intervenerType) => {
            immIntervenerList.forEach((immIntervener, index) => {
                parsedInterveners.push({
                    formaIntervencion: intervenerType === '01' || immIntervenerList.size > 1  ? ACCOUNT_INTERVENTION_INDISTINCT_CODE: ACCOUNT_INTERVENTION_OWNER_CODE,
                    numOrdenIntervencion: index + 1,
                    numeroPersona: parseInt(immIntervener.getIn(['identification','code']),10),
                    tipoIntervencion: intervenerType,
                    tipoPersona: immIntervener.getIn(['identification', 'type'])
                });
            });
        });

        const contractData = {
            productId,
            campana: '0001',
            codEstandarReferencia: standard,
            codMoneda: immAccount.getIn(['balance', 'currency']),
            cuentaSeleccionada: {
                numerodecontrato: immAccount.get('contractNumber'),
                producto: immAccount.get('product')
            },
            cuentaSeleccionadaCCC: {
                digitodecontrol: immAccount.getIn(['ibanComplex', 'digitodecontrol']),
                numerodecuenta: immAccount.get('product') + immAccount.get('contractNumber')
            },
            dataToken,
            gestor: HIRE_E_ACCOUNT_MANAGER,
            idProducto: type,
            idSubproducto: subtype,
            idioma: 'E',
            // This need to stay commented until service improvement
            // importe: findElementbyId(immContracts.get('card_details'), 'monto_traspasar'),
            indTalonario: 'N',
            lista: {
                dato: parsedInterveners
            },
            primerTitular: {
                codigodepersona: parseInt(firstTitular.getIn(['identification', 'code']), 10),
                tipodepersona: firstTitular.getIn(['identification', 'type'])
            },
            tipoCuenta: 'C'
        };

        dispatch(gdprConsentsActions.updateConsents(dataToken))
            .then(() => setEAccountLoan(dispatch, contractData, getState))
            .catch(response => {
                if(!!response.error) {
                    setEAccountLoan(dispatch, contractData, getState);
                } else {
                    throw response;
                }
            });
    };

    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
}

module.exports = {
    requestAccounts, //Request available accounts
    hireEAccountLoan //Hiring process
};